// extracted by mini-css-extract-plugin
module.exports = {"boton":"botones_boton__s2gCc"};